import { isArray, isString } from 'lodash-es';
import { highlightKeywordsInContent } from '@/utils/api';

/**
 * 文本渲染高亮
 * @param {*} content
 * @param {*} matchArr 匹配数组 matchedText 必须要！！！
 *  [
 *    {
 *      matchedText: '匹配的文本',
 *      // 其他需要的属性
 *    }
 *  ]
 * @returns
 */
function highlightContent(content, matchArr, className) {
  let result = content;
  let replaceContent = content;
  // 原文匹配上的内容去除掉，防止重复替换
  matchArr = matchArr.filter((item) => {
    const { matchedText } = item;
    // 判断是否存在匹配字符串
    if (replaceContent.includes(matchedText)) {
      replaceContent = replaceContent.replace(new RegExp(matchedText, 'g'), '');
      return true;
    }
    // 不存在则去除该项，防止无效替换
    return false;
  });

  const sortedMatchArr = [...matchArr].sort((a, b) => b.matchedText.length - a.matchedText.length);

  for (const item of sortedMatchArr) {
    // 只替换标签外的正文，避免命中已生成 span 的属性值（如 data-matchedText）。
    // 原实现用后行断言 `(?<!<[^>]*)`，Safari < 16.4 不支持，会抛 SyntaxError 让指令整体失效；
    // 改为把「完整标签」放进交替分支先行消费，等价地把标签内部排除在替换范围外。
    const regex = new RegExp(`(<[^>]*>)|${item.matchedText}`, 'g');
    let replacementBefore = `<span class="${className}"`;
    // 将对象的每一项多写入data-属性中
    Object.keys(item).forEach((key) => {
      replacementBefore += ` data-${key}="${item[key]}"`;
    });
    const replacementAfter = `>${item.matchedText}</span>`;
    // 命中的是标签本身则原样返回，只有正文分支才包裹高亮 span
    result = result.replace(regex, (match, tag) => (tag ? tag : replacementBefore + replacementAfter));
  }

  return result;
}

function render(el, binding) {
  const param = binding.value || {};

  if (isArray(param)) {
    if (!el.textContent) return;
    el.innerHTML = highlightKeywordsInContent(param, el.textContent);
  } else if (typeof param === 'object') {
    const className = param.className || '';
    let matchArr = isArray(param.matchArr) ? param.matchArr : [];

    matchArr = matchArr.map((item) => {
      if (isString(item)) {
        return {
          matchedText: item
        };
      }
      return item;
    });
    el.innerHTML = highlightContent(el.textContent || '', matchArr, className);
  }
}

const highlightStock = {
  mounted(el, binding) {
    render(el, binding);
  },
  updated(el, binding) {
    render(el, binding);
  },
  beforeUnmount() {}
};

export default highlightStock;
